<template>
  <div>
    <div class="search flex">
      <span class="tit">地区列表</span>
      <div class="flex">
        <el-button @click="toEdit(0)" size="mini" class="addBtn">添加</el-button>
        <el-input
            suffix-icon="el-icon-search"
            class="addART"
            v-model="search"
            size="mini"
            placeholder="输入关键字搜索"/>
      </div>
    </div>
    <div class="instrument">
      <el-table
          :data="cityList.filter(data => !search || data.cnName.toLowerCase().includes(search.toLowerCase()))"
          class="record-table"
          :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
          height="calc(100vh - 265px)"
          row-key="id"
          max-height="calc(100vh - 265px)">
        <el-table-column
            prop="cnName"
            label="中文名"
            width="180" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
            prop="enName"
            label="英文名" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
            prop="status"
            label="状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0" class="pink common" @click="changeStatus(scope.row)">封禁</span>
            <span v-else-if="scope.row.status === 1" class="green common" @click="changeStatus(scope.row)">启用</span>
            <span v-else @click="changeStatus(scope.row)" class="pink common">-</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="remark"
            label="备注" align="center">
        </el-table-column>
        <el-table-column
            prop="sort"
            label="排序" align="center">
          <template slot="header">
            <el-button @click="orderOk">排序</el-button>
          </template>
        </el-table-column>
        <el-table-column
            align="right"
            width="200" label="操作">
          <template slot-scope="scope">
            <el-popconfirm
                @confirm="toDelete(scope.row.id)"
                title="确定删除吗？">
              <el-button slot="reference"
                         size="mini"
                         type="text"
                         class="btn">删除
              </el-button>
            </el-popconfirm>
            <el-button @click="toEdit(scope.row)" size="mini" type="text" class="btn">编辑</el-button>
            <el-button @click="toItemList(scope.row.id)" size="mini" type="text" class="btn">管理</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-drawer
        :visible.sync="editDialog.visible"
        :wrapper-closable="false"
        :show-close="false"
        :title="(editDialog.mode==='add'?'新增':'编辑')+'子项'"
        size="700px" class="drawerCommon">
      <el-form :model="curCity" label-suffix="：" label-width="90px" class="maxHeight" ref="form" :rules="rules">
        <el-form-item label="中文名" prop="cnName">
          <el-input v-model="curCity.cnName" placeholder="请输入中文名"></el-input>
        </el-form-item>
        <el-form-item label="英文名" prop="enName">
          <el-input v-model="curCity.enName" placeholder="请输入英文名"></el-input>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="curCity.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="图片地址">
          <el-upload
              class="avatar-uploader"
              :action="uploadUrl"
              :show-file-list="false"
              name="uploadFile"
              :on-success="handleImageSuccess">
            <img v-if="curCity.imgPath" :src="curCity.imgPath" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="curCity.remark" placeholder="请输入备注"
                    :autosize="{ minRows: 2, maxRows: 5}" type="textarea">
          </el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button size="small" type="primary" @click="saveCity()">保存</el-button>
        <el-button size="small" @click="editDialog.visible=false">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import commonjs from "../../../api/common";
import Sortable from 'sortablejs';

export default {
  name: "cityList",
  data() {
    return {
      cityList: [],//城市数据
      orderCityList: [],//排序后城市
      search: '',
      curCity: {
        cnName: null,
        enName: null,
        id: null,
        imgPath: null,
        remark: null,
        sort: null,
        status: null,
        title: null,
      },
      rules: {
        cnName: [
          {required: true, message: '请填写中文名', trigger: 'blur'},
          {max: 100, message: '长度在 255 个字符之内', trigger: 'blur'}
        ],
        enName: [
          {max: 100, message: '长度在 255 个字符之内', trigger: 'blur'}
        ],
        remark: [
          {max: 255, message: '长度在 255 个字符之内', trigger: 'blur'}
        ],
        title: [
          {max: 255, message: '长度在 255 个字符之内', trigger: 'blur'}
        ],
      },
      editDialog: {
        visible: false,
        mode: 'add',
      },
      uploadUrl: commonjs.uploadUrl + "city" || ' ',
    }
  },
  mounted() {
    this.getData();
    this.rowDrop();
  },
  methods: {
    //查-list
    getData() {
      let that = this;
      this.$ajax.get(commonjs.manager_api.city.list).then((res) => {
        if (res.data.status === 'success') {
          that.cityList = res.data.list;
        } else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        console.error(err)
        that.$message.error("操作失败")
      })
    },
    //排序完成
    orderOk() {
      let that = this;
      $(this.cityList).each((index, obj) => {
        that.orderCityList[index] = obj.id;
      });
      this.$ajax.post(commonjs.manager_api.city.order, this.orderCityList).then(function (res) {
        if (res.data.status === 'success') {
          that.$message.success("排序成功");
        } else {
          that.$message.error(res.data.message);
        }
        that.getData();
      }).catch((err) => {
        console.error(err)
        that.$message.error("操作失败")
      })
    },
    toItemList(id) {
      this.$router.push({name: 'cityItemList', query: {id: id}})
    },
    //前往编辑
    toEdit(obj) {
      if (obj.id) {
        this.editDialog.mode = 'edit';
        this.curCity = obj;
      } else {
        this.editDialog.mode = 'add';
        this.curCity = {
          cnName: null,
          enName: null,
          id: null,
          imgPath: null,
          remark: null,
          sort: null,
          status: null,
          title: null,
        }
      }
      this.editDialog.visible = true;
    },
    //删除
    toDelete(id) {
      let that = this;
      this.$ajax.delete(commonjs.manager_api.city.delete.replace("{id}", id)).then(function (res) {
        if (res.data.status === 'success') {
          that.$message.success("操作成功")
          that.getData();
        } else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        console.error(err)
        that.$message.error("操作失败")
      })
    },
    //改变状态
    changeStatus(item) {
      let that = this;
      let status = (item.status + 1) % 2;
      this.$ajax.get(commonjs.manager_api.city.updateStatus.replace("{status}/{id}", status + "/" + item.id)).then(function (res) {
        if (res.data.status === 'success') {
          that.$message.success("操作成功")
          item.status = status;
        } else {
          that.$message.error(res.data.message)
        }
      }).catch((err) => {
        console.error(err)
        that.$message.error("操作失败")
      })
    },
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector('.el-table__body-wrapper tbody')
      const _this = this
      Sortable.create(tbody, {
        onEnd({newIndex, oldIndex}) {
          const currRow = _this.cityList.splice(oldIndex, 1)[0]
          _this.cityList.splice(newIndex, 0, currRow)
        }
      })
    },
    handleImageSuccess(res, file) {// 新增上传组件
      if (res.status === 'success') {
        this.curCity.imgPath = res.message;
      }
    },
    saveCity() {
      let that = this;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let url = commonjs.manager_api.city.save;
          if (that.editDialog.mode === 'edit') {
            url = commonjs.manager_api.city.update.replace("{id}", this.curCity.id);
          }
          this.$ajax.post(url, this.curCity).then((res) => {
            if (res.data.status === 'success') {
              that.$message.success('保存成功');
              that.editDialog.visible = false;
              that.getData();
            } else {
              that.$message.error(res.data.message);
            }
          }).catch(err => {
            console.error(err);
            that.$message.error("操作失败");
          });
        } else {
          this.$message.error("请检查输入");
          return false;
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/admin.scss';

.flip-list-move {
  transition: transform 1s;
}

.items {
  width: 300px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border: 1px solid red;
}

</style>
